import { render, staticRenderFns } from "./UpdateIssueButton.vue?vue&type=template&id=098440ba&"
import script from "./UpdateIssueButton.vue?vue&type=script&lang=js&"
export * from "./UpdateIssueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098440ba')) {
      api.createRecord('098440ba', component.options)
    } else {
      api.reload('098440ba', component.options)
    }
    module.hot.accept("./UpdateIssueButton.vue?vue&type=template&id=098440ba&", function () {
      api.rerender('098440ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/Buttons/UpdateIssueButton.vue"
export default component.exports